<template>
  <v-tab-item>
    <v-data-table
      :headers="headers"
      :items="items"
      no-data-text="登録されたタグはありません"
      sort-by="name"
      class="elevation-1"
      :items-per-page="100"
      dense
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>タグ編集</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <!--ダイアログ-->
          <v-dialog v-model="dialog" max-width="300px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                >タグ追加</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-text-field
                      v-model="editedItem.name"
                      label="タグ"
                    ></v-text-field>
                    <v-select
                      label="表示状態"
                      v-model="editedItem.open"
                      :items="shows"
                      item-text="text"
                      item-value="value"
                    >
                    </v-select>
                    <v-col>
                      <p>タグカラー</p>
                      <v-color-picker
                        v-model="editedItem.color"
                        class="ma-2"
                        show-swatches
                      ></v-color-picker>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close"
                  >キャンセル</v-btn
                >
                <v-btn color="blue darken-1" text @click="save">保存</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.color`]="{ item }">
        <v-btn :color="item.color" small></v-btn>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </v-tab-item>
</template>

<script>
/* eslint-disable no-console */
import store from "../../stores";
import { db } from "../../plugins/firebase";
import CommonMethods from "@/mixins/CommonMethods.js";
import TagModel from "../../Models/TagModel";
import moment from "moment";
export default {
  mixins: [CommonMethods],
  watch: {
    tags() {
      if (this.tags.length <= 0) return;
      this.items = this.tags.map((value) => {
        value.create_at = moment(value.create_at.toDate()).format("YYYY/MM/DD");
        value.update_at =moment(value.update_at.toDate()).format("YYYY/MM/DD");
        return value;
      });
    },
    dialog(val) {
      val || this.close();
    },
    "sharedState.user": {
      immediate: true,
      handler(val) {
        this.gymid = val.gymid;
      },
      deep: true,
    },
    async gymid() {
      await this.getTags();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "タグ作成" : "タグ編集";
    },
  },
  data() {
    return {
      sharedState: store.state,
      dialog: false,
      headers: [
        { text: "タグ", align: "start", value: "name" },
        { text: "タグ色", value: "color" },
        { text: "表示状態", value: "open" },
        { text: "作成日", value: "create_at" },
        { text: "更新日", value: "update_at" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      gymid: "",
      items: [],
      tags: [],
      editedIndex: -1,
      editedItem: {
        id: "",
        name: "",
        color: "#FFFFFF",
        open: true,
      },
      defaultItem: {
        name: "",
        color: "#FFFFFF",
        open: true,
      },
      shows: [
        { text: "表示(true)", value: true },
        { text: "非表示(false)", value: false },
      ],
    };
  },
  methods: {
    async getTags() {
      if (this.gymid === undefined || this.gymid === null) return;
      db.collection("M_TAG")
        .where("gymid", "==", this.gymid)
        .onSnapshot(async (snapShot) => {
          this.tags = [];
          if (snapShot.empty) return;
          snapShot.docs.forEach(async (n) => {
            var data = n.data();
            data.docId = n.id;
            this.tags.push(data);
          });
        });
    },
    editItem(item) {
      this.editedIndex = this.tags.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      confirm("このアイテムを削除してもよろしいですか？") &&
        this.delete("M_TAG", item.id);
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      try {
        var tag = new TagModel(this.gymid);
        tag.name = this.editedItem.name;
        tag.open = this.editedItem.open;
        tag.color = this.editedItem.color;
        // タグ更新
        if (this.editedIndex > -1) {
          tag.update(this.editedItem.docId, tag)
          //this.update("M_TAG", this.editedItem.docId, tag, { merge: true });
          this.$emit("alert", {
            type: "success",
            message: "タグを更新しました！",
          });
          // タグ登録
        } else {
          const obj = tag.getObject();
          // 登録
          this.create("M_TAG", obj);
          this.$emit("alert", {
            type: "success",
            message: "タグを登録しました！",
          });
        }
      } catch (err) {
        console.log(err);
        this.$emit("alert", {
          type: "error",
          message: "タグの登録に失敗しました...",
        });
      }
      this.close();
    },
  },
  firestore() {
    this.getTags();
    return {};
  },
};
</script>
